<template>
  <v-chip small class="status-chip" :color="color" outlined>
    {{ text | capitalize }}
  </v-chip>
</template>

<script>
export default {
  name: "StatusChip",
  /**
   * ----------------Props  ---------------
   */
  props: {
    text: {
      required: true,
      type: String,
    },
  },
  /**
   * ------------------Computed properties ----------------
   */
  computed: {
    /**
     * get color
     */
    color() {
      return this.$appConfig.statusChip.color[this.text.toLowerCase()];
    },
  },
};
</script>
